import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SidebarMenuBlocks from "../../components/adminNavigation/SidebarMenuBlocks";
import Button from "../../components/form/Button";
import { useSelector } from "react-redux";
import logo_image from "../../assets/images/logo.png";
import icon from "../../assets/images/fav.png";
import { useTranslation } from "react-i18next";
import { rgba, toSnakeCase } from "../../helpers";

const AdminSideBar = ({
  isMenuOpen,
  setMenuOpen = () => {},
  isHeaderExpanded = false,
}) => {
  const { t } = useTranslation();
  const { session } = useSelector((state) => state?.authProvider);
  const message = useSelector((state) => state?.message);
  const { data } = useSelector((state) => state?.profile);
  const { appliedTheme, selectedElement, status } = useSelector(
    (state) => state?.themeProvider,
  );

  const adminSidebarMenu = [
    {
      _id: "dashboard",
      menuTitle: "Dashboard",
      menuData: [
        {
          _id: "dashboard",
          menuLabel: "Dashboard",
          menuLink: "/admin/dashboard",
          menuIcon: "fa-regular fa-grid-2",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-table-columns",
    },
    {
      _id: "Media",
      menuTitle: "Media",
      menuData: [
        {
          _id: "media",
          menuLabel: "List",
          menuLink: "/admin/media",
          menuIcon: "fa-regular fa-photo-film-music",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-photo-film-music",
    },
    {
      _id: "organization",
      menuTitle: "Company",
      menuData: [
        {
          _id: "organization",
          menuLabel: "List",
          menuLink: "/admin/company",
          menuIcon: "fa-regular fa-building",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-briefcase",
    },
    {
      _id: "users",
      menuTitle: "Users",
      menuData: [
        {
          _id: "users",
          menuLabel: "List",
          menuLink: "/admin/users",
          menuIcon: "fa-regular fa-users",
          menuIconColor: "text-primary",
        },
        // {
        //   _id: "users-activity",
        //   menuLabel: "Activity",
        //   menuLink: "/admin/activity",
        //   menuIcon: "fa-regular fa-bolt",
        //   menuIconColor: "text-primary",
        // },
      ],
      mainMenuIcon: "fa-regular fa-users-gear",
    },

    {
      _id: "jobs",
      menuTitle: "Jobs",
      menuData: [
        {
          _id: "jobs",
          menuLabel: "List",
          menuLink: "/admin/jobs",
          menuIcon: "fa-regular fa-list",
          menuIconColor: "text-primary",
        },
        // {
        //   _id: "job-applications",
        //   menuLabel: "Applications",
        //   menuLink: "/admin/job-applications",
        //   menuIcon: "fa-regular fa-paper-plane",
        //   menuIconColor: "text-primary",
        // },
        {
          _id: "jobs-departments",
          menuLabel: "Departments",
          menuLink: "/admin/job-departments",
          menuIcon: "fa-regular fa-sitemap",
          menuIconColor: "text-primary",
        },
        // {
        //   _id: "jobs-category",
        //   menuLabel: "Categories",
        //   menuLink: "/admin/job-categories",
        //   menuIcon: "fa-regular fa-layer-group",
        //   menuIconColor: "text-primary",
        // },
        {
          _id: "job-skills",
          menuLabel: "Skills",
          menuLink: "/admin/job-skills",
          menuIcon: "fa-regular fa-lightbulb",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-experiences",
          menuLabel: "Experiences",
          menuLink: "/admin/job-experiences",
          menuIcon: "fa-regular fa-chart-line",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-qualifications",
          menuLabel: "Qualifications",
          menuLink: "/admin/job-qualifications",
          menuIcon: "fa-solid fa-award",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-salary-range",
          menuLabel: "Salary Range",
          menuLink: "/admin/job-salaryRange",
          menuIcon: "fas fa-money-bill-wave",
          menuIconColor: "text-primary",
        },
        // {
        //   _id: "job-products",
        //   menuLabel: "Tags",
        //   menuLink: "/admin/job-tags",
        //   menuIcon: "fa-regular fa-tags",
        //   menuIconColor: "text-primary",
        // },
        // {
        //   _id: "job-enquiry",
        //   menuLabel: "Enquiry",
        //   menuLink: "/admin/job-enquiry",
        //   menuIcon: "fa-regular fa-address-book",
        //   menuIconColor: "text-primary",
        // },
      ],
      mainMenuIcon: "fa-regular fa-briefcase",
    },
    {
      _id: "applications",
      menuTitle: "Applications",
      menuData: [
        {
          _id: "job-applications",
          menuLabel: "Applications",
          menuLink: "/admin/job-applications",
          menuIcon: "fa-regular fa-paper-plane",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-briefcase",
    },

    // {
    //   _id: "faqs",
    //   menuTitle: "Faqs",
    //   menuData: [
    //     {
    //       _id: "faq",
    //       menuLabel: "List",
    //       menuLink: "/admin/faq",
    //       menuIcon: "fa-regular fa-square-question",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "faqs-category",
    //       menuLabel: "Categories",
    //       menuLink: "/admin/faqs-categories",
    //       menuIcon: "fa-regular fa-layer-group",
    //       menuIconColor: "text-primary",
    //     },
    //     // {
    //     //   _id: "faqs-tags",
    //     //   menuLabel: "Tags",
    //     //   menuLink: "/admin/faqs-tags",
    //     //   menuIcon: "fa-regular fa-tags",
    //     //   menuIconColor: "text-primary",
    //     // },
    //   ],
    //   mainMenuIcon: "fa-regular fa-person-circle-question",
    // },
    // {
    //   _id: "Services",
    //   menuTitle: "Services",
    //   menuData: [
    //     {
    //       _id: "Services",
    //       menuLabel: "List",
    //       menuLink: "/admin/services",
    //       menuIcon: "fa-brands fa-servicestack",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "services-category",
    //       menuLabel: "Categories",
    //       menuLink: "/admin/services-categories",
    //       menuIcon: "fa-regular fa-layer-group",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "services-tags",
    //       menuLabel: "Tags",
    //       menuLink: "/admin/services-tags",
    //       menuIcon: "fa-regular fa-tags",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    //   mainMenuIcon: "fa-regular fa-briefcase",
    // },

    // {
    //   _id: "cms",
    //   menuTitle: "CMS",
    //   menuData: [
    //     {
    //       _id: "testimonial",
    //       menuLabel: "Testimonial",
    //       menuLink: "/admin/testimonial",
    //       menuIcon: "fa-regular fa-rectangle-history-circle-user",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "howItWorks",
    //       menuLabel: "How It Works",
    //       menuLink: "/admin/how-it-works",
    //       menuIcon: "fa-regular fa-diagram-project",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "enquiry",
    //       menuLabel: "Enquiry",
    //       menuLink: "/admin/enquiry",
    //       menuIcon: "fa-regular fa-address-book",
    //       menuIconColor: "text-chestnut-rose",
    //     },
    //     {
    //       _id: "pages",
    //       menuLabel: "Pages",
    //       menuLink: "/admin/page",
    //       menuIcon: "fa-regular fa-file",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "forms",
    //       menuLabel: "Forms",
    //       menuLink: "/admin/forms",
    //       menuIcon: "fa-brands fa-wpforms",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "editor",
    //       menuLabel: "Editor",
    //       menuLink: "/admin/editor",
    //       menuIcon: "fa-brands fa-wpforms",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "emails",
    //       menuLabel: "Email Templates",
    //       menuLink: "/admin/email-template",
    //       menuIcon: "fa-regular fa-envelope-open",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    //   mainMenuIcon: "fa-regular fa-folder-grid",
    // },
    // {
    //   _id: "plan&payment",
    //   menuTitle: "Plans & Payments",
    //   menuData: [
    //     {
    //       _id: "payments",
    //       menuLabel: "Payments",
    //       menuLink: "/admin/payments?tab=subscriptions",
    //       menuIcon: "fa-regular fa-bell",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "plan-list",
    //       menuLabel: "Plan List",
    //       menuLink: "/admin/plan-product",
    //       menuIcon: "fa-regular fa-money-check-dollar",
    //       menuIconColor: "text-primary",
    //     },

    //     {
    //       _id: "payment-gateway",
    //       menuLabel: "Payment Gateway",
    //       menuLink: "/admin/payment-getway",
    //       menuIcon: "fa-regular fa-wallet",
    //       menuIconColor: "text-primary",
    //     },

    //     {
    //       _id: "taxs",
    //       menuLabel: "Taxes",
    //       menuLink: "/admin/tax",
    //       menuIcon: "fa-regular fa-receipt",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "coupons",
    //       menuLabel: "Coupons",
    //       menuLink: "/admin/coupons",
    //       menuIcon: "fa-regular fa-tags",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    //   mainMenuIcon: "fa-regular fa-money-bill-1-wave",
    // },
    // {
    //   _id: "settings",
    //   menuTitle: "Settings",
    //   menuData: [
    //     {
    //       _id: "settings",
    //       menuLabel: "Site Settings",
    //       menuLink: "/admin/site-settings",
    //       menuIcon: "fa-regular fa-gear",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "organization",
    //       menuLabel: "Organization",
    //       menuLink: "/admin/organization",
    //       menuIcon: "fa-regular fa-building",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    //   mainMenuIcon: "fa-regular fa-gear-complex",
    // },
  ];

  const [expandedMenuId, setExpandedMenuId] = useState(null);

  const handleToggle = (id) => {
    setExpandedMenuId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    if (adminSidebarMenu.length > 0) {
      setExpandedMenuId(adminSidebarMenu[0]._id);
    }
  }, []);

  return (
    <div className="relative w-full">
      <div
        className={
          `relative py-4 flex items-center gap-4 transition-all duration-100 z-60 border-slate-700` +
          (isMenuOpen ? "px-3" : "px-3")
        }
        {...(appliedTheme?.customiseLogo?.backgroundColor && {
          style: {
            backgroundColor:
              "rgba(appliedTheme?.customiseLogo?.backgroundColor)",
          },
        })}
      >
        <Link className="h-12  mx-auto " to={"/"} replace>
          <img
            className="w-full h-full object-contain"
            src={
              appliedTheme?.logo instanceof File
                ? URL.createObjectURL(appliedTheme?.logo)
                : appliedTheme?.logo?.url || appliedTheme?.logo || logo_image
            }
            alt={"Logo"}
          />
        </Link>
      </div>
      <div
        className={`relative overflow-auto scroll-smooth scrollbar scrollbar-1 transition-all duration-200 px-1 ${
          isHeaderExpanded
            ? "max-h-[calc(100vh-26rem)]"
            : "max-h-[calc(100vh-16rem)]"
        }`}
      >
        {Array.isArray(adminSidebarMenu) &&
          adminSidebarMenu?.map((item, index) => {
            if (item) {
              return (
                <SidebarMenuBlocks
                  key={item._id}
                  menuTitle={item.menuTitle}
                  menuData={item.menuData}
                  mainMenuIcon={item?.mainMenuIcon}
                  isMenuOpen={isMenuOpen}
                  isExpanded={expandedMenuId === item._id}
                  onToggle={() =>
                    setExpandedMenuId((prev) =>
                      prev === item._id ? null : item._id,
                    )
                  }
                />
              );
            }
            return null;
          })}
      </div>
    </div>
  );
};

export default AdminSideBar;
